import {DetailAnnulation} from './detail-annulation.model'

export class Annulation {
    typeAnnylation: number;
    byHour: boolean;
    detail: Array<DetailAnnulation> = [];
    crHeurAnnulation: number
    public bindingData(data) {
        this.typeAnnylation = data.annulation.type;
        //        this.crHeurAnnulation = 10;
        this.crHeurAnnulation = data.crHeurAnnulation;
        this.byHour = data.annulation.isHeur;
        for (let l of data.annulation.detail) {
            let detail = new DetailAnnulation();
            detail.bindingData(l);
            this.addLine(detail);
        }
        return this;
    }
    /**
     * add detail anulation
     * @returns Room
     */
    addLine(detail: DetailAnnulation) {
        this.detail.push(detail);
        return this;
    }
    isHours(): string {
        if (this.byHour) {
//            return 'hours'
            return 'minutes'
        }
        return 'day'
    }


}